module.exports = __webpack_public_path__ + "static/media/profile_drpdwnArrow.7a2b3c0f.svg";